  <div id="containerBreadcrumb">
    <section class="content-header">
      <div class="icon-breadcrumb">
        <i class="fi-dashboard-graphic"></i>
      </div>
      <h1>
        Dashboard
        <small>{{version}}</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <!--Comentado versao 1 lite -->
            <form [formGroup]="filtro" class="dashboard-date-filter">
              <p class="data"> Período: </p>
              <p-calendar                
                class="calendar-filter"
                formControlName="periodo"
                selectionMode="range"
                dateFormat="dd/mm/yy"
                (onSelect)="onSelectDate()"
                [locale]="pt_BR"
                required
              >
              </p-calendar>
            </form>          
        </li>
        <li><a href="#"> Home</a></li>
        <li class="active">Dashboard</li>
      </ol>
    </section>
  </div>

      <div class="row dashboard-panels">
        <div style="width: 100%;">
          <div class="dashboard-summary-cards">
        <!-- Card 1: Clientes -->
        <div *ngIf="globalsVariablesService.visualizar('cadastros', 'cliente')" class="dashboard-summary-card dashboard-summary-card--clients">
          <div class="dashboard-summary-card__content">
            <div class="dashboard-summary-card__icon">
              <i class="fi-creative-users"></i>
            </div>
            <div class="dashboard-summary-card__information">
              <strong class="dashboard-summary-card__value">
                {{ mostrarOuMascara(qtdeClientes | number:'1.0-0', 'dashboard', 'dashboard') }}
              </strong>
              <span class="dashboard-summary-card__label">Meus Clientes</span>
            </div>
          </div>
          <button
            class="dashboard-summary-card__action"
            routerLink="/administrativo/cliente/new"
            aria-label="Cadastrar Cliente">
            <span>Cadastrar Cliente</span>
            <i class="fi-interface-right-arrow"></i>
          </button>
        </div>

        <!-- Card 2: Produtos -->
        <div *ngIf="globalsVariablesService.visualizar('cadastros', 'produto')" class="dashboard-summary-card dashboard-summary-card--products">
          <div class="dashboard-summary-card__content">
            <div class="dashboard-summary-card__icon">
              <i class="fi-ecommerce-package-4"></i>
            </div>
            <div class="dashboard-summary-card__information">
              <strong class="dashboard-summary-card__value">
                {{ mostrarOuMascara(qtdeProdutos | number:'1.0-0', 'dashboard', 'dashboard') }}
              </strong>
              <span class="dashboard-summary-card__label">Meus Produtos</span>
            </div>
          </div>
          <button
            class="dashboard-summary-card__action"
            routerLink="/estoque/produto-lite/new"
            aria-label="Cadastrar Produto">
            <span>Cadastrar Produto</span>
            <i class="fi-interface-right-arrow"></i>
          </button>
        </div>

        <!-- Card 3: NF-e Emitidas -->
        <div *ngIf="globalsVariablesService.visualizar('vendas', 'pedido')" class="dashboard-summary-card dashboard-summary-card--nfe">
          <div class="dashboard-summary-card__content">
            <div class="dashboard-summary-card__icon">
              <i class="fi-ecommerce-coins"></i>
            </div>
            <div class="dashboard-summary-card__information">
              <strong class="dashboard-summary-card__value">
                {{ mostrarOuMascara(qtdeNFSaidas | number:'1.0-0', 'dashboard', 'dashboard') }}
              </strong>
              <span class="dashboard-summary-card__label">Quantidade NFes emitidas no mês</span>
            </div>
          </div>
          <button
            class="dashboard-summary-card__action"
            routerLink="/comercial/pedido/new"
            aria-label="Emitir NFe">
            <span>Emitir NFe</span>
            <i class="fi-interface-right-arrow"></i>
          </button>
        </div>

        <!-- Card 4: Valor Total NF-e -->
        <div *ngIf="globalsVariablesService.visualizar('vendas', 'pdv')" class="dashboard-summary-card dashboard-summary-card--value">
          <div class="dashboard-summary-card__content">
            <div class="dashboard-summary-card__icon">
              <i class="fi-dashboard-pie-graphic"></i>
            </div>
            <div class="dashboard-summary-card__information">
              <strong class="dashboard-summary-card__value">
                {{ mostrarOuMascara(valorVendas | number:'1.2-2', 'dashboard', 'dashboard') }}
              </strong>
              <span class="dashboard-summary-card__label">Valor Total NFes emitidas no mês</span>
            </div>
          </div>
          <button
            class="dashboard-summary-card__action"
            routerLink="/comercial/pdv/new"
            aria-label="Emitir Venda PDV">
            <span>Emitir Venda PDV</span>
            <i class="fi-interface-right-arrow"></i>
          </button>
        </div>
          </div>
        </div>
      </div>
      <!-- <iframe title="Report Section" width="1024" height="804" src="{{urlPowerBI}}" frameborder="0" allowFullScreen="true"></iframe> 
        https://app.powerbi.com/reportEmbed?reportId=95e52b11-9e69-4686-be23-458f43f7fe0a&autoAuth=true&ctid=370dfae3-7c16-45f6-a317-c63106a02f10
      -->

      <!-- Iframe Power-BI
         <iframe title="BI-Curso" width="1024" height="804" src="https://app.powerbi.com/view?r=eyJrIjoiOWVmZjU5YjktMTE4OC00ZjAwLThkZGMtMGE2NjRhNzY4MTlhIiwidCI6IjM3MGRmYWUzLTdjMTYtNDVmNi1hMzE3LWM2MzEwNmEwMmYxMCJ9" frameborder="0" allowFullScreen="true">
         </iframe>
       -->
       
    <!-- *ngIf="globalsVariablesService.getPermissoes.visualizarDashboard"  -->
    <section *ngIf="globalsVariablesService.visualizar('dashboard', 'dashboard')"
             class="ui-sm-12 ui-md-6 ui-lg-4 connectedSortable ui-sortable">
      <div class="graphs-custom box box-solid">
        <p-card [style]="{ width: '360px'}">
          <ng-template pTemplate="header">
            <label>Vendas e Compras </label>
          </ng-template>
          <div class="ui-g">
            <p-chart type="pie" [data]="dadosEntradaSaida" [options]="optionsEntradaSaida"></p-chart>
          </div>
          <ng-template pTemplate="footer">
          </ng-template>
        </p-card>
      </div>
    </section>

    <section *ngIf="globalsVariablesService.visualizar('dashboard', 'dashboard')"
      class="ui-sm-12 ui-md-6 ui-lg-4  connectedSortable ui-sortable">
    
      <div class="graphs-custom box box-solid">
        <p-card [style]="{ width: '360px'}">
          <ng-template pTemplate="header">
            <label>Contas a Receber e Pagar </label>
          </ng-template>
          <div class="ui-g">
            <p-chart type="pie" [data]="dadosReceberPagar" [options]="optionsReceberPagar"></p-chart>
          </div>
          <ng-template pTemplate="footer">
          </ng-template>
        </p-card>
      </div>
    </section>
    <section *ngIf="globalsVariablesService.visualizar('dashboard', 'dashboard')"
      class="ui-sm-12 ui-md-6 ui-lg-4  connectedSortable ui-sortable">
      <div class="graphs-custom box box-warning">
        <div class="box-header ui-sortable-handle">
          <i class="fi-ecommerce-like-1"></i>
          <h3 class="box-title">Últimas Notificações</h3>
        </div>
        <div class="box-body">
          <ul class="todo-list ui-sortable">
            <li>
              <span class="handle ui-sortable-handle">
                <i class="fa fa-ellipsis-v"></i>
                <i class="fa fa-ellipsis-v"></i>
              </span>
              <span class="text"> Qtde Dias para vencer o certificado : </span>
              <small class="label label-danger" style="font-size: 100%;"><i class="fa fa-clock-o"></i>
                {{mensagemCertificado}}</small>
            </li>
            <li>
              <span class="handle ui-sortable-handle">
                <i class="fa fa-ellipsis-v"></i>
                <i class="fa fa-ellipsis-v"></i>
              </span>
              <span class="text"> Licença do Sistema expira em  </span>
              <small  class="label label-danger" style="font-size: 100%; margin-left: 2px;"><i class="fa fa-clock-o"></i>
                {{ globalsVariablesService.getDiasLicenca}}</small>
              <span class="text">dias </span>
            </li>
            <li>
              <span class="handle ui-sortable-handle">
                <i class="fa fa-ellipsis-v"></i>
                <i class="fa fa-ellipsis-v"></i>
              </span>
              <span class="text"> Acesso aos boletos do Mês  </span>
              <small  class="label label-danger" style="font-size: 100%; margin-left: 2px;"><i class="fa fa-clock-o"></i>
                <a routerLink="/administrativo/boleto-cliente" class="small-box-footer">
                    Clique Aqui
                </a>                
              </small>              
            </li>
            <!-- <li>
              <span class="handle ui-sortable-handle">
                <i class="fa fa-ellipsis-v"></i>
                <i class="fa fa-ellipsis-v"></i>
              </span>
              <span class="text"> Qtde de contratos há vencer : </span>
              <small class="label label-danger" style="font-size: 100%;"><i class="fa fa-clock-o"></i>
                {{mensagemQtdeContratos}}
              </small>
            </li> -->
          </ul>
        </div>
      </div>
    
    </section>
